import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Heading, IconDate, NamedLink } from '../../components';

import css from './ModalMissingInformation.module.css';

/**
 * Google Calendar sync reminder content for ModalMissingInformation.
 *
 * @component
 */
const CalendarSyncReminder = props => {
  const { className, onClose } = props;

  return (
    <div className={className}>
      <IconDate className={css.calendarModalIcon} />
      <Heading as="h1" rootClassName={css.modalTitle}>
        <FormattedMessage id="ModalMissingInformation.syncCalendarTitle" />
      </Heading>
      <p className={css.modalMessage}>
        <FormattedMessage id="ModalMissingInformation.syncCalendarDescription" />
      </p>

      <div className={css.buttonWrapper}>
        <NamedLink name="NewListingPage" className={css.syncCalendarButton} onClick={onClose}>
          <FormattedMessage id="ModalMissingInformation.syncCalendarButtonText" />
        </NamedLink>
      </div>
    </div>
  );
};

export default CalendarSyncReminder;
